<template>
  <div class="app-container">
    <div class="navbar">
      <div class="logo">
        <img src="~@/assets/images/logo-sm.png" alt="">
        <h3><img src="~@/assets/images/new-logo-tit.png" alt=""></h3>
      </div>
    </div>
    <div class="userRegister">
      <div class="register-bar">
        <h3>用户注册</h3>
        <div class="back" @click="login">
          <a-button type="primary"
          ><i class="iconfont icon-fanhuiicon mr5"></i> 前往登陆</a-button
          >
        </div>
      </div>
      <div class="register-content" style="height: 100%; overflow-y: auto; overflow-x: hidden;">
        <a-form
            ref="formRef"
            style="margin-top: 30px"
            :model="form"
            name="basic"
            :rules="rules"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 6 }"
        >
          <!-- 账户信息部分 -->
          <div class="register-section">
            <a-form-item label="手机号" name="linkPhone">
              <a-input v-model:value="form.username" placeholder="手机号" />
            </a-form-item>
            <a-form-item label="验证码" name="verifyCode">
              <a-row :gutter="8">
                <a-col :span="14">
                  <a-input v-model:value="form.code" placeholder="请输入验证码" />
                </a-col>
                <a-col :span="10">
                  <a-button 
                    type="primary" 
                    :disabled="countDown > 0" 
                    @click="getVerifyCode"
                    style="width: 100%;"
                  >
                    {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="密码" name="password">
              <password-input
                  @focus="inputPassFocus"
                  v-model:value="form.password"
                  placeholder="请输入密码"
              />
            </a-form-item>
            <a-form-item label="确认密码" name="repassword">
              <password-input
                  @focus="inputRepassFocus"
                  v-model:value="form.repassword"
                  placeholder="请重新输入密码"
              />
            </a-form-item>
          </div>
          
          <!-- 企业认证部分 -->
<!--          <div class="register-section">-->
<!--            <h4 class="section-title">企业认证</h4>-->
<!--            <a-form-item label="公司名称" name="name">-->
<!--              <a-input v-model:value="form.name" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="法人姓名">-->
<!--              <a-input v-model:value="form.corporationName" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="统一信用代码">-->
<!--              <a-input v-model:value="form.unifyCode" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="联系人姓名" name="linkName">-->
<!--              <a-input v-model:value="form.linkName" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="联系人电话" name="linkPhone">-->
<!--              <a-input v-model:value="form.linkPhone" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="联系地址">-->
<!--              <a-input v-model:value="form.address" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="邮箱">-->
<!--              <a-input v-model:value="form.email" placeholder="请输入" />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="申请主体类型">-->
<!--              <a-radio-group v-model:value="form.category">-->
<!--                <a-radio-->
<!--                    v-for="(item, index) in typeList"-->
<!--                    :key="item.id"-->
<!--                    :value="item.dataCode + ''"-->
<!--                    @change="radioChange"-->
<!--                >-->
<!--                  {{ item.dataValue }}-->
<!--                  <div v-if="item.dataValue === '其它科技型企业' && flag">-->
<!--                    <input class="old_inp" type="text" v-model="userInput" />-->
<!--                  </div>-->
<!--                </a-radio>-->
<!--              </a-radio-group>-->
<!--            </a-form-item>-->
<!--            <a-form-item label="资质附件" name="licenseAttachmentArr" tooltip="企业需上传公司营业职照，高校/研究所需上传单位证明">-->
<!--              <images-uploader-->
<!--                  v-model:image-urls="form.licenseAttachmentArr"-->
<!--                  :path-name="'license'"-->
<!--                  :max-count="2"-->
<!--                  :box-width="180"-->
<!--                  :box-height="120"-->
<!--                  @upload-success="handleUploadSuccess"-->
<!--                  @delete="handleDelete"-->
<!--              />-->
<!--              &lt;!&ndash; 将tooltip内容移到图片上传组件下面 &ndash;&gt;-->
<!--              <div class="tooltip-text">-->
<!--                企业需上传公司营业职照，高校/研究所需上传单位证明-->
<!--              </div>-->
<!--            </a-form-item>-->
<!--          </div>-->

          <a-form-item
              style="margin-top: 40px"
              :wrapper-col="{ span: 7, offset: 10 }"
          >
            <a-button type="primary" ghost @click="cancel">取消</a-button>
            <a-button type="primary" style="margin-left: 60px" @click="confirm"
            >立即注册</a-button
            >
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import { message, Modal } from "ant-design-vue";
import { useRouter } from "vue-router";
import { getTermsServiceList } from '@/api/enterprise/index';
import { register } from '@/api/login';
import imagesUploader from '@/components/imagesUploader/index.vue'
import PasswordInput from '@/components/PasswordInput';

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const router = useRouter();

const dataType = "companyType";
const dataCode = "category";

const termsOfServiceUrls = ref([]);

const checkAge = async (_rule, value) => {
  if (!value) {
    return Promise.reject("请输入电话号码");
  } else {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的电话号码");
    } else {
      return Promise.resolve();
    }
  }
};
const checkCardNo = async (_rule, value) => {
  if (value) {
    const reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的身份证号码");
    } else {
      return Promise.resolve();
    }
  }
};

const checkRePsw = async (_rule, value) => {
  console.log(_rule, form.value);
  if (!value) {
    return Promise.reject("请再次输入密码");
  } else {
    if (form.value.password != value) {
      return Promise.reject("密码不一致，请检查");
    } else {
      return Promise.resolve();
    }
  }
};

let typeList = ref([]); // 单选框选择

watch(
    () => appStore.SysDictVOList,
    (val) => {
      console.log(val);
      if (val.length > 0) {
        const index = val.findIndex((item) => item.dataType === dataType);
        typeList.value = val[index].children;
        console.log(typeList.value);
      }
    },
    {
      deep: true,
      immediate: true,
    }
);

const userInput = ref("");

const formRef = ref();
const form = ref({
  username: "",
  code: "",
  password: "",
  repassword: "",

  // name: "",
  // unifyCode: "",
  // corporationName: "",
  // linkPhone: "",
  // linkName: "",
  // address: "",
  // email: "",
  // category: "int",
  // licenseAttachmentArr: [],  // 改为数组

});

const reset = () => {
  form.value = {
    username: "",
    password: "",
    repassword: "",
    code: ""
  };
  flag.value = false;
  userInput.value = "";
};  

// 验证码倒计时
const countDown = ref(0);
const getVerifyCode = () => {
  if (!form.value.username) {
    message.error('请输入手机号');
    return;
  }
  
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!phoneReg.test(form.value.username)) {
    message.error('请输入正确的手机号');
    return;
  }
  
  // 模拟发送验证码
  message.success('验证码已发送');
  
  // 开始倒计时
  countDown.value = 60;
  const timer = setInterval(() => {
    countDown.value--;
    if (countDown.value <= 0) {
      clearInterval(timer);
    }
  }, 1000);
};

const rules = {
  username: [{ required: true, message: "手机号不能为空", trigger: "change" }],
  code: [
    { required: true, message: "请输入验证码", trigger: "blur" },
    { len: 6, message: "验证码为6位数字", trigger: "blur" },
    { pattern: /^\d{6}$/, message: "验证码只能包含数字", trigger: "blur" }
  ],
  password: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, max: 66, message: "长度在 6 个字符以上", trigger: "blur" },
  ],
  repassword: [{ required: true, trigger: "blur", validator: checkRePsw }]
};

const flag = ref(false);

const radioChange = (e) => {
  console.log(e.target.value);
  if (e.target.value === "other") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};

const inputPassFocus = (e) => {
  console.log(e.target.value);
  form.value.password = "";
};

const inputRepassFocus = (e) => {
  console.log(e.target.value);
  form.value.repassword = "";
};

const login = () => {
  router.replace('/login').then(() => {
    window.location.reload();
  });
}

const handleUploadSuccess = (url, urls) => {
  console.log('上传成功', url);
  console.log('当前所有图片', urls);
};

const handleDelete = (index) => {
  console.log('删除图片索引', index);
};

// 保存
const confirm = () => {
  console.log("注册");
  formRef.value
      .validate()
      .then(() => {
        console.log("values", form.value);
        const body = JSON.parse(JSON.stringify(form.value));
        console.log(body);

        register(body).then((res) => {
          if (res.code === 200) {
            // 显示注册成功提示模态框
            Modal.success({
              title: '注册成功',
              content: '您的账号已注册成功，请前往登录页面登录。',
              okText: '前往登录',
              onOk() {
                router.push({
                  path: "/login",
                });
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log("error", error);
      });
};
// 取消
const cancel = () => {
  console.log("取消");
  formRef.value.resetFields();
  reset();
  router.replace('/login').then(() => {
    window.location.reload();
  });
};

onMounted(async () => {
  try {
    getTermsServiceList({ funcCode: 'terms_service' }).then(res => {
      termsOfServiceUrls.value = res.data;
    })
  } catch (error) {
    console.error('获取产品服务协议URL失败:', error);
  }
});
</script>
<style lang="less" scoped>

.app-container {
  padding-top: 70px;
}

.navbar {
  width: 100%;
  height: 70px;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  // background: #fff url(~@/assets/images/top_bg.png) no-repeat;
  padding: 10px 31px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 888888;

  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .logo {
    display: flex;
    align-items: center;

    img {
      max-height: 60px;
    }

    h3 {
      margin: 0 0 0 16px;
      font-size: 28px;
      color: #fff;
      font-family: DingTalk;
    }
  }
}

.userRegister {
  padding: 20px;
  margin-top: 0;
  height: calc(100vh - 70px);
  background-color: #ffffff;

  .back {
    position: fixed;
    top: 93px;
    right: 50px;
  }
}

.old_inp {
  /* 移除原生边框 */
  border: none;
  /* 添加新边框*/
  border-bottom: 1px solid #000;
  /* 左侧内边距 */
  // padding-left: 10px;
  /* 输入框宽度 */
  width: 100px;
  /* 移除点击输入框时浏览器提供的默认轮廓 */
  outline: none;
  position: absolute;
  bottom: 12px;
  left: 130px;
}

/deep/.ant-radio-wrapper {
  padding: 6px 0 10px 0;
}

/deep/.ant-radio-wrapper {
  width: 139px;
}


.uploaded-files {
  margin-top: 10px;
  border: 1px dashed #d9d9d9;
  padding: 10px;
  border-radius: 4px;
}

.register-section {
  margin-top: 120px;
  margin-bottom: 10px;
  padding-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
  margin-left: 0;
  padding-left: 60px;
}

.tooltip-text {
  color: #68767e;
  font-size: 14px;
  margin-top: 8px;
  font-family: PingFang SC-Regular, PingFang SC;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}

.file-item:last-child {
  border-bottom: none;
}

.file-item a-icon {
  color: #ff4d4f;
  cursor: pointer;
}
</style>
